export default __webpack_public_path__ + "static/media/delete.940277f7.svg";